<template>
  <Layout style="background: #21343b">
    <h2 slot="title" class="text-center" style="color: white">{{ $t('joinWorkspace') }}</h2>
    <p slot="desc" class="desc text-center mb-0">
      {{ $t('joinWorkspaceRequestDesc') }}
    </p>
    <form slot="content" class="text-center mt-15">
      <v-container>
        <v-row>
          <v-col class="pt-0 pb-0 text-center">
            <v-avatar
              :color="(passedWsInfo.wsLogo === undefined ? passedWsInfo.wsName : '') | iconBackground"
              class="logo"
              rounded
              size="50"
              style="cursor: pointer"
            >
              <span class="white--text text-sm-h6 cent" v-if="!passedWsInfo.wsLogo">
                {{ passedWsInfo.wsName | iconFilter }}
              </span>
              <v-img :src="passedWsInfo.wsLogo" v-else />
            </v-avatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="company pt-0 pb-4 mt-3 mb-16 text-center">
            {{ passedWsInfo.wsName }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-btn
              block
              elevation="0"
              height="40"
              :disabled="!isBtnAble || isLoading"
              :loading="isLoading"
              :class="'btn-' + (isBtnAble ? 'able' : 'disable')"
              id="sendAccessRequest"
              @click="setRequestJoinWs"
            >
              {{ $t('sendAccessRequest') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="showMsg">
          <v-col class="pt-0 pb-0 mt-5">
            <v-alert dense outlined>
              <span v-html="errorMessage" />
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </form>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { setRequestJoinWs } from '@/services/api'

export default {
  name: 'RequestWorkspace',
  components: {
    Layout,
  },
  props: ['passedWsInfo'],
  async created() {
    if (!this.passedWsInfo) {
      this.$router.replace({ name: 'Workspace' })
      return false
    }
  },
  data: () => ({
    isBtnAble: true,
    isLoading: false,
    showMsg: false,
    errorCode: '',
    errorMessage: '',
  }),
  computed: {
    wsNameFirstChar() {
      return this.passedWsInfo.wsName.toUpperCase().charAt(0)
    },
  },
  methods: {
    async setRequestJoinWs() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      try {
        await setRequestJoinWs(this, this.passedWsInfo.wsId, this.$store.getters.userName)
        this.$router.replace({ name: 'CompleteWorkspace', params: { passedType: 'request' } })
      } catch (error) {
        this.errorCode = typeof error.response !== 'undefined' ? error.response.data : error.message

        this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))

        console.log(this.errorCode, this.errorMessage)

        this.showMsg = true
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
